import { Box, LinearProgress, Rating, Stack, Tooltip, Typography } from "@mui/material"
import React, { useMemo } from "react"
import { ReviewsArray, ReviewSummaryProps } from "../types"

const getReviewSummaryProps = (reviews: ReviewsArray, totalAverage: number): ReviewSummaryProps => {
    return {
        fiveStarCount: reviews.filter(e => e.rating === 5).length,
        fourStarCount: reviews.filter(e => e.rating === 4).length,
        threeStarCount: reviews.filter(e => e.rating === 3).length,
        twoStarCount: reviews.filter(e => e.rating === 2).length,
        oneStarCount: reviews.filter(e => e.rating === 1).length,
        totalCount: reviews.length,
        totalAverage
    }
}
const StarRatingSummary = ({ starCount, totalCount, star }: { starCount: number, totalCount: number, star: number }) => {
    return (
        <Stack direction={'row'} gap={2} justifyContent={"space-between"} alignItems={"center"}>
            <Rating
                size="small"
                precision={0.2}
                readOnly
                value={star}
            />
            <Tooltip title={`${starCount} out of ${totalCount}`}>
                <Box sx={{ width: '140px' }}><LinearProgress aria-label={`Star rating for ${starCount} stars`} style={{ height: 10, width: '100%', borderRadius: '10px' }} variant="determinate" value={((starCount) / totalCount) * 100} /></Box>
            </Tooltip>
            <Box sx={{ width: '25px' }}>
                <Typography>{starCount}</Typography>
            </Box>
        </Stack>
    )
}


export const ReviewSummary = ({ reviews, totalAverage }: { reviews: ReviewsArray, totalAverage: number }) => {
    const { totalCount, fiveStarCount, fourStarCount, threeStarCount, twoStarCount, oneStarCount } = useMemo(() => {
        return getReviewSummaryProps(reviews, totalAverage)
    }, [])

    return (
        <Box sx={{ pl: 3, pr: 3 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} gap={2} alignItems={{ xs: 'center', sm: 'center', md: 'flex-start' }} justifyContent={{ xs: "flex-start", sm: "flex-start", md: "space-between" }}>
                <Box sx={{ textAlign: { xs: 'center', sm: 'center', md: 'inherit' } }}>
                    <Rating
                        size="large"
                        precision={0.2}
                        readOnly
                        value={totalAverage}
                    />
                    <Typography>{totalAverage} out of 5</Typography>
                    <Typography>Based on {totalCount} reviews</Typography>
                </Box>
                <Stack gap={0.3}>
                    <StarRatingSummary star={5} totalCount={totalCount} starCount={fiveStarCount} />
                    <StarRatingSummary star={4} totalCount={totalCount} starCount={fourStarCount} />
                    <StarRatingSummary star={3} totalCount={totalCount} starCount={threeStarCount} />
                    <StarRatingSummary star={2} totalCount={totalCount} starCount={twoStarCount} />
                    <StarRatingSummary star={1} totalCount={totalCount} starCount={oneStarCount} />
                </Stack>
            </Stack>
        </Box>
    )
}